import type { InventoryProduct } from '../../lib/api.js';
import type {
  InventoryActivityFilter,
  InventoryBaseUnit,
  InventoryLossReason,
  InventoryLotTracking,
  InventoryLotTrackingFilter,
  InventoryMovementKind,
} from '../../lib/api.js';

export interface InventoryCapabilities {
  canManageProducts: boolean;
  canManageLocations: boolean;
  canRegisterMovements: boolean;
  canReverseMovements: boolean;
  canManageReplenishment: boolean;
  /// Atalho para vender o produto, presente só quando a empresa contratou Vendas e a pessoa pode
  /// registrar venda. O Estoque não conhece Vendas: quem liga o atalho é a casca da tela.
  onSell?: ((product: InventoryProduct) => void) | undefined;
}

/// Conversão positiva com até seis casas: a mesma regra do domínio, repetida aqui só para a pessoa
/// ser avisada antes de mandar. Quem decide continua sendo o servidor.
export const BASE_QUANTITY = /^\d{1,11}(?:[.,]\d{1,6})?$/u;

export const baseUnitLabels: Record<InventoryBaseUnit, string> = {
  UNIT: 'Unidade',
  MILLILITER: 'Mililitro (ml)',
  GRAM: 'Grama (g)',
};
export const baseUnitOptions = (Object.keys(baseUnitLabels) as InventoryBaseUnit[]).map(
  (value) => ({ value, label: baseUnitLabels[value] }),
);
export const lotTrackingLabels: Record<InventoryLotTracking, string> = {
  NONE: 'Sem lote obrigatório',
  REQUIRED: 'Lote obrigatório',
};
export const lotTrackingOptions = (Object.keys(lotTrackingLabels) as InventoryLotTracking[]).map(
  (value) => ({ value, label: lotTrackingLabels[value] }),
);
export const activityOptions: Array<{ value: InventoryActivityFilter; label: string }> = [
  { value: 'ALL', label: 'Todos' },
  { value: 'ACTIVE', label: 'Ativos' },
  { value: 'INACTIVE', label: 'Arquivados' },
];
export const lotFilterOptions: Array<{ value: InventoryLotTrackingFilter; label: string }> = [
  { value: 'ALL', label: 'Todos' },
  { value: 'REQUIRED', label: 'Com lote' },
  { value: 'NONE', label: 'Sem lote' },
];
export const movementKindLabels: Record<InventoryMovementKind, string> = {
  ENTRY: 'Entrada',
  CONSUMPTION: 'Consumo',
  LOSS: 'Perda',
  ADJUSTMENT: 'Ajuste',
  TRANSFER: 'Transferência',
};
export const lossReasonLabels: Record<InventoryLossReason, string> = {
  EXPIRATION: 'Vencimento',
  BREAKAGE: 'Quebra, derramamento ou contaminação',
  THEFT: 'Furto ou extravio',
  INTERNAL_USE: 'Uso interno ou demonstração',
};
export const lossReasonOptions = (Object.keys(lossReasonLabels) as InventoryLossReason[]).map(
  (value) => ({ value, label: lossReasonLabels[value] }),
);

/// `500.000000` é o que o banco guarda; `500` é o que a pessoa escreveu. A casa decimal só aparece
/// quando ela existe de fato.
export function trimQuantity(value: string): string {
  return value.includes('.') ? value.replace(/\.?0+$/u, '') : value;
}

export function shortUnit(unit: InventoryBaseUnit): string {
  return { UNIT: 'unidades', MILLILITER: 'ml', GRAM: 'g' }[unit];
}
